<template>
	<div class="component-sub-frame-page" :style="{ height: windowHeight }">
		<SimpleVScroll>
			<SmartDisplayC :compId="activeModuleId" :mode="getDisplayType" />
		</SimpleVScroll>
	</div>
</template>

<script>
export default {
	name: 'ComponentFrameSub'
};
</script>
<script setup>
import { getCurrentInstance, computed, onMounted } from 'vue';
import { SimpleVScroll } from '@/view/enterprise_rebuild/components/scroll';
import SmartDisplayC from '@/view/enterprise_rebuild/components/SmartDisplayC.vue';
import { useModuleAttrs } from '@rebuild/hooks/useModuleAttrs';
import { get100vh } from '@/utils/api';
import { IrstoreTracker as IrTrack } from '@/utils/tracker';
import { resolveStoreId, resolvePageId } from '@rebuild/utils/context';

const windowHeight = get100vh();
const vm = getCurrentInstance();
const { searchModuleIdWithParams, searchModule, isCustomM } = useModuleAttrs();
const activeModuleId = computed(() => {
	const moduleId = vm.proxy.$route.params?.moduleId;
	return searchModuleIdWithParams(moduleId);
});
const getDisplayType = computed(() => vm.proxy.$route.params?.subPath);

const addViewTrack = () => {
	const moduleId = vm.proxy.$route.params?.moduleId;
	const findModule = searchModule(moduleId);
	if (findModule) {
		IrTrack.send({
			curPage: '投资者关系专栏',
			content: '浏览页面',
			event: 'VIEW',
			module: '投资者关系专栏',
			params: {
				'浏览模块名称': findModule.name,
				'浏览模块类型': isCustomM(findModule) ? '自定义模块' : '系统模块',
				'企业ID': resolveStoreId(),
				'页面ID': resolvePageId()
			}
		});
	}
};
onMounted(() => {
	addViewTrack();
});
</script>

<style lang="less" scoped></style>
